import Imatge from 'components/corporatiu/Imatge';
// @ts-ignore
import EnllacComponent from 'components/corporatiu/Enllac/Enllac';
import styles from './instruccionsIngres.module.scss';

const Enllac = EnllacComponent as React.ComponentType<{
    href?: string;
    novaFinestra?: boolean;
    className?: string;
    children: React.ReactNode;
}>;

const STATICS_HOST = 'https://statics.3cat.cat';

export default function InstruccionsIngres() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.caixa}>
                <p>
                    Podeu fer l&apos;ingrés des de l&apos;apartat{' '}
                    <Enllac href='https://espai-entitats-marato.3cat.cat/entitat/recaptacio'>La teva recaptació</Enllac>
                </p>
                <p>Preferentment feu el pagament amb targeta</p>
                <p>Feu un únic ingrés per entitat organitzadora</p>
                <p>Si ho preferiu, ho podeu fer a la vostra oficina bancària</p>
            </div>

            <div className={styles.caixa}>
                <h2>Ingrés a l&apos;oficina bancària</h2>
                <ul>
                    <li>
                        Podeu ingressar per finestreta la recaptació obtinguda mitjançant les activitats promogudes per la vostra
                        entitat. Eviteu portar monedes.
                    </li>
                    <li>
                        Feu l&apos;ingrés al número de compte:
                        <div className={styles.codisCaixa}>
                            <Imatge
                                src={`${STATICS_HOST}/marato/img/espai-entitats/logo-la-caixa-stext.png`}
                                alt='Logo La Caixa'
                                width={46}
                                height={40}
                            />
                            <span className={styles.compte}>ES55 2100 - 0555 - 37 - 0201474332</span>
                        </div>
                    </li>
                    <li>Feu constar el vostre número d&apos;entitat organitzadora i el nom de la vostra entitat.</li>
                    <li>
                        Si excepcionalment heu de fer més d&apos;un ingrés, serà necessari que contacteu amb nosaltres a{' '}
                        <Enllac href='mailto:activitatsperlamarato@3cat.cat'>activitatsperlamarato@3cat.cat</Enllac> i ens envieu
                        la còpia de tots els resguards en un únic correu electrònic (espereu a tenir-los tots). Especifiqueu en
                        l&apos;assumpte del correu electrònic: ingrés múltiple i codi d&apos;entitat.
                    </li>
                    <li>Recordeu de demanar-li al banc el comprovant bancari.</li>
                    <li>
                        Faciliteu{' '}
                        <Enllac href='https://www.3cat.cat/tv3/marato/butlleta-ingres/' novaFinestra={false}>
                            aquesta butlleta
                        </Enllac>{' '}
                        al responsable de fer l&apos;ingrés de la vostra entitat organitzadora perquè el presenti a l&apos;oficina
                        bancària.
                    </li>
                </ul>
            </div>

            <p className={styles.agraiment}>
                Moltes gràcies per col·laborar amb{' '}
                <Imatge
                    src={`${STATICS_HOST}/recursos/marato/img/logos/logo-lamarato.svg`}
                    alt='La Marató de 3Cat, logotip'
                    width={188}
                    height={38}
                />
            </p>
        </div>
    );
}
